/* ===== Product page gift wrap: one gift wrap per order, plus the order's gift message ===== */
class ProductGiftwrapOffer extends HTMLElement {
  constructor() {
    super();
    this.handleToggle = this.handleToggle.bind(this);
    this.handleCartAdded = this.handleCartAdded.bind(this);
    this.syncFromCart = this.syncFromCart.bind(this);
  }

  connectedCallback() {
    this.toggle = this.querySelector('[data-giftwrap-toggle]');
    this.message = this.querySelector('[data-giftwrap-message]');
    this.messageInput = this.querySelector('[data-giftwrap-message-input]');
    this.error = this.querySelector('[data-giftwrap-error]');

    this.toggle?.addEventListener('change', this.handleToggle);
    window.eventBus?.on('cart:added', this.handleCartAdded);
    window.addEventListener('pageshow', this.syncFromCart);
    this.syncFromCart();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('change', this.handleToggle);
    window.eventBus?.off?.('cart:added', this.handleCartAdded);
    window.removeEventListener('pageshow', this.syncFromCart);
  }

  async syncFromCart() {
    /* ===== Reflect the order: tick the box if gift wrap is already in the cart, and show the saved message ===== */
    try {
      const cart = await this.getCart();
      this.toggle.checked = this.hasGiftWrap(cart);
      if (this.messageInput && !this.messageInput.value) {
        this.messageInput.value = cart.attributes?.gift_note || '';
      }
      this.handleToggle();
    } catch (error) {
      console.error('Failed to read cart for gift wrap:', error);
    }
  }

  handleToggle() {
    if (this.message) this.message.hidden = !this.toggle.checked;
  }

  async handleCartAdded(event) {
    /* ===== Only act for this product's form ===== */
    const productForm = document.getElementById(this.dataset.formId)?.closest('product-form');
    if (!productForm || event?.sectionId !== productForm.dataset.sectionId) return;

    if (this.error) this.error.hidden = true;

    try {
      const cart = await this.getCart();
      const wrapInCart = this.hasGiftWrap(cart);
      const wrapWanted = this.toggle.checked;
      const payload = {};

      if (wrapWanted) {
        payload.updates = { [this.variantId]: 1 };
        if (this.messageInput) payload.attributes = { gift_note: this.messageInput.value.trim() };
      } else if (wrapInCart) {
        payload.updates = { [this.variantId]: 0 };
      } else {
        return;
      }

      const isDrawer = !!document.querySelector('cart-drawer');
      if (isDrawer) payload.sections = 'cart-drawer';

      const response = await fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const responseJson = await response.json();
      if (!response.ok || responseJson.status) {
        throw new Error(responseJson.description || responseJson.message);
      }

      if (isDrawer) window.eventBus.emit('update:cart:drawer', responseJson);
      this.updateCartCount();
    } catch (error) {
      console.error('Gift wrap update failed:', error);
      if (this.error) {
        this.error.textContent = error.message || 'Gift wrap could not be added, please try again from the basket.';
        this.error.hidden = false;
      }
    }
  }

  async getCart() {
    const response = await fetch(`${window.routes.cart_url}.js`);
    return response.json();
  }

  hasGiftWrap(cart) {
    return cart.items.some((item) => item.variant_id === this.variantId);
  }

  async updateCartCount() {
    try {
      const response = await fetch(`${window.routes.cart_url}?view=compare`);
      window.wetheme?.updateCartCount?.(await response.json());
    } catch (error) {
      console.error('Failed to update cart count:', error);
    }
  }

  get variantId() {
    return parseInt(this.dataset.variantId);
  }
}

if (!customElements.get('product-giftwrap-offer')) {
  customElements.define('product-giftwrap-offer', ProductGiftwrapOffer);
}
